<template>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar flat color="#008dd4" dark>
                <v-btn icon @click="$parent.validations_dialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Pendientes de verificación</v-toolbar-title>
            </v-toolbar>

            <v-container>
                <v-row align="center" justify="center">
                    <v-col lg="8" md="10" sm="12" xs="12">
                        <v-data-table
                        :headers="headers"
                        :items="pendings"
                        :loading="loading"
                        :footer-props="footer_props"
                        :loading-text="loading_text"
                        :no-data-text="no_data_text"
                        :no-results-text="no_result_text"
                        :search="search"
                        >
                            <template v-slot:item.fullname="{ item }">
                                {{ item.user.names +" "+ item.user.paternal_surname +" "+ item.user.maternal_surname }}
                            </template>

                            <template v-slot:item.proof="{ item }">
                                <v-btn icon @click="show_image(item)">
                                    <v-icon>mdi-image-search</v-icon>
                                </v-btn>
                            </template>

                            <template v-slot:item.actions="{ item }">
                                <v-tooltip top>
                                    <template v-slot:activator="{ attrs, on }">
                                        <v-btn icon color="red" v-bind="attrs" v-on="on" @click="refuse(item)" :loading="item.refuse" :disabled="item.success">
                                            <v-icon>mdi-close-thick</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Rechazar</span>
                                </v-tooltip>

                                <v-tooltip top>
                                    <template v-slot:activator="{ attrs, on }">
                                        <v-btn icon color="green" v-bind="attrs" v-on="on" @click="accept(item)" :loading="item.success" :disabled="item.refuse">
                                            <v-icon>mdi-check-bold</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Aceptar</span>
                                </v-tooltip>
                                
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>

        <v-dialog v-model="image" width="800">
            <v-card>
                <v-card-title class="grey lighten-2">
                    Comprobante : {{ user_names }}
                </v-card-title>

                <v-card-text class="py-3">
                    <v-img :src="image_url"></v-img>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="image = false">
                    Cerrar
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-dialog>
</template>
<script>

import  iziToast from 'izitoast'

export default {
    props: ['dialog', 'url', 'pendings', 'refuse_url', 'accept_url'],
    data: () => ({

        items:[],

        //dialog
        image: false,
        user_names:"",
        image_url:"",

        //data table props
        color:"#818181",
        search:"",
        loading: false,
        loading_text:"Cargando...",
        no_data_text:"Sin elementos registrados",
        no_result_text:"Sin coincidencias",
        headers:[
            { text:'ID', value:'id' },
            { text:'Instituto', value:'institute.code' },
            { text:'Nombre', value:'fullname' },
            { text:'Fecha de registro', value:'created_at' },
            { text:'Comprobante', value:'proof'},
            { text: 'Acciones', value:'actions', sorteable:false}
        ],
        footer_props:{
            itemsPerPageText:"Filas por página",
            showCurrentPage:true,
            itemsPerPageAllText:"Todo"
        }
    }),

    methods:{
        show_image:function(item){
            this.image_url = "/storage/proof_institute/"+item.proof;
            this.user_names = item.user.names +" "+ item.user.paternal_surname +" "+ item.user.maternal_surname
            this.image = true
        },

        refuse:function(item){
            item.refuse = true
            let data = {}
            data.proof_id = item.id
            axios.post(this.refuse_url, data).then(response => {
                if(response.data.success){
                    iziToast.success({
                        position:'topRight',
                        title:'Correcto',
                        message:'Notificación enviada correctamente'
                    })
                    this.pendings.splice(this.pendings.indexOf(item), 1)
                }
            }).catch(error => { })
        },

        accept:function(item){
            item.success = true
            let data = {}
            data.proof_id = item.id
            axios.post(this.accept_url, data).then(response => {
                iziToast.success({
                    position:'topRight',
                    title:'Correcto',
                    message:'Notificación enviada correctamente'
                })
                this.pendings.splice(this.pendings.indexOf(item), 1)
            })
        }
    }
}
</script>
